import apiClient from 'api/client';

const FileUploader = async (e, metadata) => {
  const tns_tenant = '03534add672340809e2c70314b1ce20e';
  const file = e.target.files[0];
  if (file && file.size > metadata.uploadConfig.maxFileSizeMB * 1024 * 1024) {
    console.log(
      `File size exceeds the limit of ${metadata.uploadConfig.maxFileSizeMB} MB.`
    );
    throw new Error(
      `File size exceeds the limit of ${metadata.uploadConfig.maxFileSizeMB} MB.`
    );
  } else {
    const formData = new FormData();
    formData.append('file', file);
    try {
      const response = await apiClient.post(
        `/digitization/v1${metadata.uploadConfig.uploadEndpoint}`,
        formData
      );
      console.log('File uploaded successfully:', response.data);
      const file = response.data.results.file_key;
      const url = response.data.results.url;
      return { file, url };
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  }
};

export const FileDecoder = async encryptUrl => {
  if (encryptUrl != '') {
    try {
      const response = await apiClient.get(
        `/digitization/v1/utility/get/file?file_key=${encryptUrl}`
      );
      console.log('File URL received successfully:', response.data);
      const decryptUrl = response.data.results.url;
      return decryptUrl;
    } catch (error) {
      console.error('Error decoding file:', error);
    }
  }
};

export default FileUploader;
